import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=3d8c01d3&"
import script from "./UserBlock.vue?vue&type=script&lang=js&"
export * from "./UserBlock.vue?vue&type=script&lang=js&"
import style0 from "./UserBlock.vue?vue&type=style&index=0&id=3d8c01d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports